import React from 'react';
import { Box, FormControl, InputLabel, Select as MuiSelect, MenuItem, Checkbox, ListItemText, Typography, FormHelperText } from '@mui/material';
import CustomChip from '../chips/CustomChip';

const Select = ({
  label,
  value,
  options,
  onChange,
  disabled = false,
  fullWidth = true,
  multiple = false,
  formWidth = '100%',
  helperText = '',
  size = 'medium',
  formControlSx = {},
  labelSx = {},
  selectSx = {},
  menuItemSx = {},
  ...props
}) => {
  const getOptionByValue = (val) => options.find((option) => option.value === val);

  const renderSingleOption = (option) => {
    if (!option) return '';

    const shouldShowRecommendedChip = option.isRecommended || option.chipLabel;
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
        <span>{option.label}</span>
        {shouldShowRecommendedChip ? (
          <Box sx={{ ml: '2px' }}>
            <CustomChip
              label={option.chipLabel || 'recommended'}
              size="small"
              color="#EEF2FF"
              textColor="#1D4ED8"
              border
              borderColor="#BFDBFE"
            />
          </Box>
        ) : null}
      </Box>
    );
  };

  return (
    <FormControl 
      variant="outlined"
      size={size}
      sx={{
        width: { xs: '100%', md: formWidth },  // 100% on mobile, 20% on desktop
        ...formControlSx,
      }}
      error={helperText ? true : false}  // Adds error styling if helper text is provided
    >
      <InputLabel id={`${label}-label`} sx={labelSx}>{label}</InputLabel>
      <MuiSelect
        labelId={`${label}-label`}
        id={`${label}-select`}
        value={value}
        onChange={onChange}
        label={label}
        disabled={disabled}
        size={size}
        multiple={multiple}
        sx={selectSx}
        renderValue={(selected) =>
          multiple
            ? selected.map(
                (val) => options.find((option) => option.value === val)?.label
              ).join(', ')
            : renderSingleOption(getOptionByValue(value))
        }
        {...props}  // Spread other props like MenuProps if passed down
      >
        {options.length === 0 ? (
          <MenuItem disabled>
            <Typography variant="body2" color="textSecondary" sx={menuItemSx}>
              No items available
            </Typography>
          </MenuItem>
        ) : (
          options.map((option) => (
            <MenuItem key={option.value} value={option.value} sx={menuItemSx}>
              {multiple && (
                <Checkbox checked={value.includes(option.value)} />
              )}
              <ListItemText primary={renderSingleOption(option)} />
            </MenuItem>
          ))
        )}
      </MuiSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}  {/* Conditionally render helper text */}
    </FormControl>
  );
};

export default Select;